/**
 * Utility function to process rich text content for display
 * Handles line breaks, markdown formatting, and basic HTML sanitization
 */

export const processRichText = (content) => {
  if (!content) return '';
  
  // Convert line breaks to HTML breaks
  let processedContent = content.replace(/\r?\n/g, '<br/>');
  
  // Handle basic markdown formatting
  // Bold text: **text** or __text__
  processedContent = processedContent.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  processedContent = processedContent.replace(/__(.*?)__/g, '<strong>$1</strong>');
  
  // Italic text: *text* or _text_
  processedContent = processedContent.replace(/\*(.*?)\*/g, '<em>$1</em>');
  processedContent = processedContent.replace(/_(.*?)_/g, '<em>$1</em>');
  
  // Handle bullet points with checkmarks: ☑ or ✓
  processedContent = processedContent.replace(/☑\s*(.*?)(?=<br\/>|$)/g, '<span class="inline-flex items-center"><span class="text-green-600 mr-2">☑</span>$1</span>');
  processedContent = processedContent.replace(/✓\s*(.*?)(?=<br\/>|$)/g, '<span class="inline-flex items-center"><span class="text-green-600 mr-2">✓</span>$1</span>');
  
  // Handle bullet points with asterisks only
  processedContent = processedContent.replace(/^\*\s*(.*?)$/gm, '<span class="inline-flex items-center"><span class="mr-2">•</span>$1</span>');
  
  return processedContent;
};

/**
 * Component wrapper for rich text content
 * Provides consistent styling and safe HTML rendering
 */
export const RichTextContent = ({ content, className = "" }) => {
  const processedContent = processRichText(content);
  
  return (
    <div
      className={`font-flex-regular prose max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: processedContent }}
    />
  );
};
